import { useCallback } from 'react';

import { CostReviewLineItemApplicableRecommendation } from './cost-review-line-item-applicable-recommendation';
import { CostReviewLineItemAppliedRecommendation } from './cost-review-line-item-applied-recommendation';

/**
 * @param {object} props
 * @param {import('../../../prop-types/cost-review.types').CostReviewRecommendation} props.recommendation
 * @param {boolean} props.isRecommendationSelected
 * @param {(recommendationKey: string) => void} props.onToggleRecommendation
 * @param {boolean} props.isToggleRecommendationDisabled
 * @returns {React.JSX.Element}
 */
export const CostReviewLineItemRecommendation = ({
  recommendation,
  isRecommendationSelected,
  onToggleRecommendation,
  isToggleRecommendationDisabled = false,
}) => {
  const toggleRecommendation = useCallback(() => {
    onToggleRecommendation(recommendation.key);
  }, [onToggleRecommendation, recommendation.key]);

  return isRecommendationSelected ? (
    <CostReviewLineItemAppliedRecommendation
      isToggleRecommendationDisabled={isToggleRecommendationDisabled}
      onToggleRecommendation={toggleRecommendation}
      recommendation={recommendation}
    />
  ) : (
    <CostReviewLineItemApplicableRecommendation
      isToggleRecommendationDisabled={isToggleRecommendationDisabled}
      onToggleRecommendation={toggleRecommendation}
      recommendation={recommendation}
    />
  );
};
